import { render, staticRenderFns } from "./multipleMarubatsu.vue?vue&type=template&id=1157f94c&scoped=true"
import script from "./multipleMarubatsu.vue?vue&type=script&lang=ts"
export * from "./multipleMarubatsu.vue?vue&type=script&lang=ts"
import style0 from "./multipleMarubatsu.vue?vue&type=style&index=0&id=1157f94c&prod&scoped=true&lang=css"
import style1 from "./multipleMarubatsu.vue?vue&type=style&index=1&id=1157f94c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1157f94c",
  null
  
)

export default component.exports